import { PrimaryRoadCarrier } from "../../../types/models/RoadCarrier";
import RoadCarrierName from "./RoadCarrierName";
    
import * as React from 'react';
import { NavLink } from "react-router";
import Link, { LinkProps } from '@mui/material/Link';
import {useDispatch} from "react-redux";
import {ID} from "../../../../types/global";
import {ReactElement} from "react";

interface LinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

type IFormProps = {
    icon: ReactElement,
    id: ID;

};

function LinkRouter(props: LinkRouterProps) {
    return <Link {...props} component={NavLink as any} />;
}

export const linkPath = async (dispatch, id) => {
    
    const prefix = ''
    return `${prefix}/road-carriers/${PrimaryRoadCarrier.fromId(id).toPath()}`
}

const RoadCarrierLink: React.FC<IFormProps> = ({id, icon}) => {
    
    const dispatch = useDispatch()
    const [link, setLink] = React.useState('')
    
    React.useEffect(() => {
        linkPath(dispatch, id)
            .then(setLink)
    }, [id])

    if (id)
        if (link)
            return (
                <LinkRouter to={ `/dashboard${link}` } viewTransition={true}>
                    <RoadCarrierName id={id}/> { icon && icon }
                </LinkRouter>
            )
        else
            return (<RoadCarrierName id={id}/>)
    else
        return undefined
}
export default RoadCarrierLink;
